var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"izc-wrapper p-5 bg-gray-50"},[_c('div',{staticClass:"flex mb-5"},[_c('Button',{on:{"click":_vm.backToGenealogyMain}},[_vm._v("返回")])],1),_c('NoteTree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }